import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const GroupsNavigationMobileContainer = styled.div<{ $fixed?: boolean }>`
    width: 100%;
    height: 100px;
    background-color: #0a071b;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;

    @keyframes groups-navigator-mobile-slidein {
        from {
            transform: translateY(-100%);
        }

        to {
            transform: translateY(0);
        }
    }

    ${({ $fixed }) =>
        $fixed &&
        css`
            position: fixed;
            z-index: 9;
            animation-duration: 300ms;
            animation-name: groups-navigator-mobile-slidein;
        `};
`;

export const GroupsNavigationMobileMask = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    mask-image: linear-gradient(90deg, transparent, black 0%, black calc(100% - 36px), transparent);
`;

export const GroupsNavigationMobileScroll = styled.div`
    width: 100%;
    overflow-y: auto;
    display: flex;
    -webkit-overflow-scrolling: touch;
    z-index: 0;

    scrollbar-width: none; // Firefox
    -ms-overflow-style: -ms-autohiding-scrollbar; // IE10+
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
        display: none;
    } // Chrome, Safari, Edge
`;

export const GroupsNavigationMobileList = styled.div`
    padding: 10px 100px 14px 72px;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const GroupsNavigationMobileLogo = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    background: linear-gradient(90deg, rgba(10, 7, 27, 1) 50%, rgba(10, 7, 27, 0) 100%);
    width: 72px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const GroupLogoMobileLink = styled(Link)`
    &&& {
        position: relative;
        svg {
            margin-top: -8px;
            width: 36px;
            height: 36px;
            position: relative;
            will-change: transform;
        }
    }
`;

export const GroupItemSkeletonMobile = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
`;

export const GroupItemNameSkeleton = styled.div`
    width: 40px;
    height: 8px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 100px;
    flex-shrink: 0;
`;

export const GroupCreateNewPodTextMobile = styled.div`
    font-weight: 500;
    font-size: 10px;
    line-height: 10px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #ffffff;
`;
